<template>
    <div class="menu-container">
        <button
            @click="toggleMenu"
            class="menu-button"
            :disabled="disabled"
            aria-label="Options menu"
        >
            <span class="hamburger-line" />
            <span class="hamburger-line" />
            <span class="hamburger-line" />
        </button>
        <div
            v-if="isOpen"
            class="menu-dropdown"
        >
            <button
                @click="handleExportCSV"
                class="menu-item"
            >
                Export CSV
            </button>
        </div>
    </div>
</template>

<script setup lang="ts">
import { ref } from 'vue';

interface Props {
    disabled?: boolean;
}

defineProps<Props>();

const emit = defineEmits<{
    exportCSV: [];
}>();

const isOpen = ref(false);

const toggleMenu = () => {
    isOpen.value = !isOpen.value;
};

const handleExportCSV = () => {
    emit('exportCSV');
    isOpen.value = false;
};
</script>

<style scoped lang="scss">
.menu-container {
    position: relative;
}

.menu-button {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    width: 32px;
    height: 32px;
    background: transparent;
    border: none;
    cursor: pointer;
    padding: 8px;
    box-sizing: border-box
}

.menu-button:disabled {
    opacity: 0.5;
    cursor: not-allowed;
}

.hamburger-line {
    width: 18px;
    height: 3px;
    background: #333;
    transition: 0.3s;
}

.menu-dropdown {
    position: absolute;
    top: 100%;
    right: 0;
    margin-top: 4px;
    background: white;
    border: 1px solid #ccc;
    border-radius: 4px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    z-index: 1000;
    min-width: 120px;
}

.menu-item {
    display: block;
    width: 100%;
    padding: 8px 12px;
    background: none;
    border: none;
    text-align: left;
    cursor: pointer;
    font-size: 14px;
    color: #000;
}

.menu-item:hover {
    background: #f5f5f5;
}
</style>